<template>
    <div class="verify">
        <div>
            <Tabs :animated="false" @on-click="changeType">
                <TabPane v-for="type in types" :label="type.name" :name="type.id.toString()">
                    <div class="button-list">
                        <Button v-for="subType in subTypesMap[type.id]" shape="circle" :type="currentSubTypeId===subType.id?'primary':'ghost'" size="large" @click="changeSubType(subType.id)">{{subType.name}}</Button>
                    </div>
                </TabPane>
            </Tabs>
        </div>
        <ul class="msg-list">
            <li v-for="msg in msgs" class="one-msg">
                <span class="unread-icon" v-if="(msg.msgStatus === 1|| msg.msgStatus === 5 )&& (msg.typeWeight===2||msg.typeWeight===3)"></span>
                <span class="create-time">{{msg.msgTime}}</span>
                <h2>{{msg.msgDesc}}</h2>
                <div class="msgContent">
                    <p>{{msg.content}}</p>
                </div>
                <div class="action-area">
                    <span class="text-info" v-show="(msg.msgStatus === 5 || msg.msgStatus === 6) && msg.typeWeight===1">已读</span>
                    <a class="btn btn-link" v-show="msg.msgStatus === 5 && msg.typeWeight!==1" @click="handle(msg)">{{getBtnTextByMessage(msg)}}</a>
                    <a class="btn btn-link" v-show="msg.msgStatus === 1 && msg.typeWeight!==1" @click="handle(msg)">{{getBtnTextByMessage(msg)}}</a>
                    <span class="text-info" v-show="msg.msgStatus === 2">已过期</span>
                    <span class="text-info" v-show="msg.msgStatus === 3">已解决</span>
                    <span class="text-info" v-show="msg.msgStatus === 4">无法解决</span>
                </div>
            </li>
        </ul>
        <div class="pagination">
            <Page :page-size="LIST_COUNT" :current="page" :total="paging.total" @on-change="changePage" show-total>

            </Page>
        </div>
    </div>

</template>
<script>
    import {
        getCategoryList,
        getList,
        readAllMessage,
        handleMsg,
        update
    } from "api/tripNotify";
    import { LandingPageMap } from "data/notification";
    // 几个获取列表的常量
    const LIST_COUNT = 20;
    const LIST_CONDITION = 0; //全部
    const LIST_NEEDHANDLE = false;

    export default {
        data() {
            return {
                types: [{ name: "全部", id: 0 }],
                subTypesMap: { 0: [] },
                currentTypeId: 0,
                currentSubTypeId: null,
                page: 1,
                msgs: [],
                paging: {
                    count: 0,
                    page: 1,
                    total: 0
                },
                modal: true,
                handleResultList: [
                    {
                        id: 3,
                        name: "已解决"
                    },
                    {
                        id: 4,
                        name: "无法解决"
                    }
                ],
                handleResult: 3,
                LIST_COUNT
            };
        },
        async created() {
            this.currentSubTypeId = this.routerSubTypeId;
            try {
                const res = await getCategoryList(0);
                if (res.data) {
                    for (let categoryType of res.data) {
                        this.types.push({
                            name: categoryType.categoryName,
                            id: categoryType.categoryCode
                        });
                        let subTypeMsgs = categoryType.msgTypeVOList;
                        if (subTypeMsgs && subTypeMsgs.length) {
                            this.subTypesMap[categoryType.categoryCode] = subTypeMsgs.map(
                                subType => {
                                    let newSubType = {
                                        id: subType.typeId,
                                        name: subType.typeDesc,
                                        weight: subType.typeWeight
                                    };
                                    return newSubType;
                                }
                            );
                        }
                        this.subTypesMap[0] = this.subTypesMap[0].concat(
                            this.subTypesMap[categoryType.categoryCode] || []
                        );
                    }
                    if (this.subTypesMap && !this.currentSubTypeId) {
                        this.currentSubTypeId = this.subTypesMap[this.currentTypeId][0].id;
                    }
                }
            } catch (e) {
                console.log(e);
            }
        },
        watch: {
            currentSubTypeId: function() {
                this.resetPage();
                this.updateList();
            },
            currentTypeId: function() {
                this.currentSubTypeId = this.subTypesMap[this.currentTypeId][0].id;
            },
            routerSubTypeId: function() {
                this.currentSubTypeId = this.routerSubTypeId;
            }
        },
        computed: {
            routerSubTypeId: function() {
                return parseInt(this.$route.query.categoryId, 10) || null;
            }
        },
        methods: {
            updateList: async function() {
                if (this.currentSubTypeId) {
                    try {
                        let res = await getList({
                            typeId: this.currentSubTypeId,
                            needHandle: LIST_NEEDHANDLE,
                            condition: LIST_CONDITION,
                            page: this.page,
                            count: LIST_COUNT
                        });
                        this.msgs = res.data;
                        let currentSubType = this.subTypesMap[this.currentTypeId].find(
                            subType => {
                                return subType.id === this.currentSubTypeId;
                            }
                        );
                        if (currentSubType && currentSubType.weight === 1) {
                            readAllMessage([this.currentSubTypeId]);
                        }
                        if (res.paging) {
                            this.paging = res.paging;
                        }
                    } catch (e) {}
                }
            },
            changeSubType: function(index) {
                this.currentSubTypeId = index;
            },
            changeType: function(name) {
                this.currentTypeId = parseInt(name, 10);
            },
            getBtnTextByMessage: function(msg) {
                const landPageInfo = LandingPageMap[msg.typeId || msg.msgTypeId];
                return landPageInfo ? "去处理" : "已联系BD";
            },
            handle: function(msg) {
                const landPageInfo = LandingPageMap[this.currentSubTypeId];
                if (landPageInfo) {
                    const params = {};
                    let msgId = (msg && msg.broadCastId) || null;
                    handleMsg(msgId);
                    if (landPageInfo.urlPattern) {
                        window.open(
                            landPageInfo.urlPattern.replace("$bizKey", msg.bizKey),
                            "_blank"
                        );
                        this.updateList();
                        return;
                    }
                    params[landPageInfo.paramName] = msg.bizKey;
                    this.$router.push({ name: landPageInfo.stateName, params });
                    return;
                }
                if (msg.redirectUrl) {
                    try {
                        const confirmStatus = async function() {
                            try {
                                await update({
                                    msgId: msg.msgId,
                                    status: this.handleResult
                                });
                            } catch (e) {
                                this.$Notice.error({
                                    title: "接口错误",
                                    desc: e.message
                                });
                            }
                        };
                        this.$Modal.confirm({
                            title: "处理结果",
                            onOk: confirmStatus.bind(this),
                            render: h => {
                                return h(
                                    "Select",
                                    {
                                        props: {
                                            value: 3
                                        },
                                        style: {
                                            marginTop: "20px"
                                        },
                                        on: {
                                            "on-change": this.optionChangeHander
                                        }
                                    },
                                    [
                                        ...this.handleResultList.map(item => {
                                            return h("Option", {
                                                props: {
                                                    value: item.id,
                                                    key: item.id
                                                },
                                                domProps: {
                                                    innerHTML: item.name
                                                }
                                            });
                                        })
                                    ]
                                );
                            }
                        });
                    } catch (e) {
                        console.log(e);
                    }
                    this.updateList();
                }
            },
            optionChangeHander: function(val) {
                this.handleResult = val;
            },
            changePage: function(page) {
                this.page = page;
                this.updateList();
            },
            resetPage() {
                this.page = 1;
            }
        },
        mounted() {}
    };
</script>
<style>
.verify {
  margin: 20px 30px;
}
.verify .tbo-tabs-nav-scroll {
  font-size: 18px;
}
</style>
<style lang="postcss" scoped type="text/postcss">
.button-list {
  border-bottom: 1px solid #ccd2df;
  padding: 5px 0 10px;
  > button {
    margin-right: 10px;
    margin-bottom: 10px;
  }
}
.msg-list {
  list-style: none;
  li {
    border-bottom: 1px solid #ccd2df;
    padding: 10px 0;
    position: relative;
    .create-time {
      position: absolute;
      right: 25px;
      top: 15px;
      color: #8a8484;
    }
    .msgContent p {
      margin-bottom: 0;
    }
    .unread-icon {
      position: absolute;
      top: 20px;
      left: -12px;
      border-radius: 10px;
      width: 7px;
      height: 7px;
      border-radius: 10px;
      background-color: #ff6230;
      box-shadow: 0 1px 4px 0 rgba(255, 98, 48, 0.39);
    }
    .btn-link {
      padding: 0;
      min-width: auto;
    }
    .action-area {
      padding: 6px 0;
    }
  }
}
.pagination {
  width: 100%;
  text-align: right;
  padding: 20px;
  margin: 0;
}
</style>


// WEBPACK FOOTER //
// verify.vue?6e1fd37b